import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { KeyRound, Eye, EyeOff, ShieldCheck } from "lucide-react";

export default function AdminProfile() {
  const { user } = useAuth();
  const [pw, setPw] = useState({ old_password: "", new_password: "", confirm: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const changePw = async () => {
    if (pw.new_password !== pw.confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await api.post("/profile/change-password", { old_password: pw.old_password, new_password: pw.new_password });
      toast.success("Admin password changed!");
      setPw({ old_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-5 max-w-lg">
      <h1 className="text-2xl md:text-3xl font-heading font-extrabold">Admin Profile</h1>
      <div className="card-thali flex items-center gap-3">
        <span className="w-12 h-12 rounded-xl bg-thali-saffron text-white grid place-items-center shadow-btn-saffron"><ShieldCheck className="w-6 h-6" /></span>
        <div>
          <div className="font-heading font-bold">{user?.name}</div>
          <div className="text-sm text-thali-ink/60">{user?.mobile} · Administrator</div>
        </div>
      </div>

      <div className="card-thali space-y-3">
        <div className="flex items-center gap-2 font-heading font-bold text-lg text-thali-green"><KeyRound className="w-5 h-5" /> Change Password</div>
        <div className="relative">
          <input className="input-thali pr-12" type={show ? "text" : "password"} placeholder="Current password" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} data-testid="admin-pw-old" />
          <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-thali-ink/50">{show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}</button>
        </div>
        <input className="input-thali" type={show ? "text" : "password"} placeholder="New password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} data-testid="admin-pw-new" />
        <input className="input-thali" type={show ? "text" : "password"} placeholder="Confirm new password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} data-testid="admin-pw-confirm" />
        <button onClick={changePw} disabled={busy} className="btn-3d-green w-full" data-testid="admin-pw-submit">{busy ? "…" : "Change Password"}</button>
      </div>
    </div>
  );
}
